const path = 'TermsConditionsModule';
const apiPath = '/admin-panal/policy-versions';

const TermsAndConditionsActions = {
  // action types
  GET_TERMS: `${path}/getTerms`,
  UPDATE_TERMS : `${path}/updateTerms`,
}


const TermsAndConditionsAPIsConstants = {
  // api's
  API_PATH : `${apiPath}`,
  GET_API_PATH : `${apiPath}/tos`,
}

export { TermsAndConditionsActions,TermsAndConditionsAPIsConstants , path as ModuleName };
